type Benefit = {
  n: string;
  title: string;
  body: string;
  ref: string;
};

const BENEFITS: Benefit[] = [
  {
    n: "01",
    title: "Answers the ring.",
    body:
      "Picks up on the first ring, any hour. Sounds like a human. We spent six months on that.",
    ref: "Voice · Retell",
  },
  {
    n: "02",
    title: "Books the calendar.",
    body:
      "Dash reads and writes your Cal.com. If the slot is free, it confirms. If not, it offers the next.",
    ref: "Calendar · Cal.com",
  },
  {
    n: "03",
    title: "Sends the summary.",
    body:
      "Who called. What they want. When. A flag if they need a callback. In your inbox within seconds.",
    ref: "Mail · Resend",
  },
  {
    n: "04",
    title: "Keeps the record.",
    body:
      "Transcript, recording, caller ID. Searchable, exportable, yours. Delete any time.",
    ref: "Memory · Supabase",
  },
];

export default function Benefits() {
  return (
    <section className="v3-container v3-benefits">
      {BENEFITS.map((b) => (
        <article className="v3-benefit" key={b.n}>
          <div className="v3-benefit-n">
            <b>{b.n}</b>
          </div>
          <h3 className="v3-benefit-title">{b.title}</h3>
          <div>
            <p className="v3-benefit-body">{b.body}</p>
          </div>
          <div className="v3-benefit-ref">{b.ref}</div>
        </article>
      ))}
    </section>
  );
}
